import React from "react";
import loadable from "@loadable/component";
import APIS from "../../contants/Endpoints";
import useGetHook from "../../customHooks/useGetHook";
import { useParams, useSearchParams } from "react-router-dom";
import usePaginationState from "../../customHooks/usePaginationHook";
const StockComponent = loadable(() => import("../../components/Stock"));

type Props = {};

const Stock = (props: Props) => {
  const { pageSize, setPageSize, offset, setOffset } = usePaginationState();
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search") || "";
  const { id } = useParams()

  const { data: stockData, isPending: stockLoading } = useGetHook({
    queryKey: ["category", pageSize, offset, searchQuery],
    url: `${APIS.CATEGORY}`,
    params: {
      limit: pageSize,
      offset: offset,
      ...(searchQuery && { search: searchQuery }),
    },
  });
  return (
    <>
      <StockComponent
        stockData={stockData}
        stockLoading={stockLoading}
        pageSize={pageSize}
        setPageSize={setPageSize}
        offset={offset}
        setOffset={setOffset}
      />
    </>
  );
};

export default Stock;
